<div fxFlex="100" class="shared-issue trace-errors">
  <div class="simple-header">
    <div class="container">
      <a href="https://behamics.com">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          width="140"
          height="38.457"
          viewBox="0 0 140 38.457"
        >
          <defs>
            <clipPath id="a">
              <path
                d="M9.421,4.29c4.128,0,7.53,3.608,7.53,8.284s-3.4,8.283-7.53,8.283a5.93,5.93,0,0,1-4.7-1.914v1.475H0V-1.546H0A4.726,4.726,0,0,1,4.726,3.18V6.2a5.93,5.93,0,0,1,4.7-1.91ZM8.476,16.4a3.59,3.59,0,0,0,3.75-3.828,3.59,3.59,0,0,0-3.75-3.828,3.59,3.59,0,0,0-3.75,3.828A3.59,3.59,0,0,0,8.476,16.4Zm15.409-1.945c.6,1.632,2.048,2.2,3.781,2.2a4.124,4.124,0,0,0,3.025-1.192l3.781,2.165A8.006,8.006,0,0,1,27.6,20.857c-5.388,0-8.728-3.608-8.728-8.284A8.061,8.061,0,0,1,27.256,4.29a7.937,7.937,0,0,1,8,8.284,9.086,9.086,0,0,1-.189,1.882ZM46.82,4.708c3.182,0,5.892,2.259,5.892,6.5v9.633h0a4.726,4.726,0,0,1-4.726-4.726V11.894a2.593,2.593,0,0,0-2.741-2.855c-1.733,0-2.93,1-2.93,3.232v8.566h0a4.726,4.726,0,0,1-4.726-4.726V-1.128h0A4.726,4.726,0,0,1,42.314,3.6V6.622A5.4,5.4,0,0,1,46.82,4.708Zm46.458.023c3.623,0,5.986,2.573,5.986,6.5v9.633h0a4.726,4.726,0,0,1-4.726-4.727v-4.5c0-1.569-.757-2.573-2.269-2.573-1.575,0-2.458,1.1-2.458,2.949v8.848h0a4.726,4.726,0,0,1-4.726-4.726v-4.5c0-1.569-.756-2.573-2.269-2.573-1.575,0-2.458,1.1-2.458,2.949v8.848h0a4.726,4.726,0,0,1-4.726-4.726V5.17h4.726V6.614A4.843,4.843,0,0,1,84.58,4.732,4.7,4.7,0,0,1,88.709,6.8a5.2,5.2,0,0,1,4.569-2.071Zm9.288,11.418V5.187h4.726V20.876a4.726,4.726,0,0,1-4.726-4.726ZM23.79,10.942h6.775a3.242,3.242,0,0,0-3.34-2.479A3.251,3.251,0,0,0,23.79,10.942Zm44-6.227h4.726V20.4H67.79V18.929a5.93,5.93,0,0,1-4.69,1.914c-4.128,0-7.53-3.608-7.53-8.284s3.4-8.284,7.53-8.284a5.93,5.93,0,0,1,4.69,1.914ZM64.06,16.4a3.59,3.59,0,0,0,3.75-3.828,3.75,3.75,0,0,0-7.5,0A3.59,3.59,0,0,0,64.06,16.4ZM105.307,3.348A2.859,2.859,0,0,1,102.471.525a2.836,2.836,0,1,1,5.671,0,2.859,2.859,0,0,1-2.836,2.824ZM118.73,20.856a8.145,8.145,0,0,1-8.35-8.284,8.339,8.339,0,0,1,15.471-4.267l-4.128,2.385a3.265,3.265,0,0,0-3.057-1.757,3.459,3.459,0,0,0-3.56,3.64,3.459,3.459,0,0,0,3.56,3.64,3.232,3.232,0,0,0,3.057-1.757l4.128,2.353a8.048,8.048,0,0,1-7.121,4.048ZM132.249,9.309c0,1.789,7.751.6,7.751,6.4,0,3.608-3.151,5.146-6.554,5.146-3.151,0-5.545-1.192-6.774-3.734l4.1-2.322a2.587,2.587,0,0,0,2.678,1.851c1.134,0,1.7-.345,1.7-.973,0-1.726-7.751-.816-7.751-6.244,0-3.42,2.9-5.146,6.176-5.146a6.9,6.9,0,0,1,6.144,3.357L135.686,9.81a2.288,2.288,0,0,0-2.111-1.381c-.819,0-1.323.314-1.323.878Z"
                transform="translate(0 2.311)"
                fill="#fff"
              ></path>
            </clipPath>
            <clipPath id="b">
              <path
                d="M0,21.031H140.127V-2.195H0Z"
                transform="translate(0 2.195)"
                fill="#fff"
              ></path>
            </clipPath>
          </defs>
          <g transform="translate(-885 -1237)">
            <g transform="translate(-304 807)">
              <g transform="translate(1174.419 348.937)">
                <g transform="translate(14.581 81.063)">
                  <g clip-path="url(#a)">
                    <g transform="translate(0 0.011)" clip-path="url(#b)">
                      <path
                        d="M0,21.907H140.968V-2.286H0Z"
                        transform="translate(0 1.318)"
                        fill="#fff"
                      ></path>
                    </g>
                  </g>
                </g>
              </g>
            </g>
            <path
              d="M.3,11.286V.342H1.565v4.04h.107q.139-.214.385-.545a2.255,2.255,0,0,1,.716-.6,2.577,2.577,0,0,1,1.272-.267,3.258,3.258,0,0,1,1.828.518,3.449,3.449,0,0,1,1.234,1.47A5.267,5.267,0,0,1,7.55,7.2a5.331,5.331,0,0,1-.444,2.26,3.5,3.5,0,0,1-1.229,1.475,3.214,3.214,0,0,1-1.812.518A2.627,2.627,0,0,1,2.8,11.2a2.347,2.347,0,0,1-.732-.6q-.257-.342-.4-.566h-.15v1.261Zm1.24-4.1a4.564,4.564,0,0,0,.273,1.641,2.477,2.477,0,0,0,.8,1.106,2.067,2.067,0,0,0,1.283.4,2.067,2.067,0,0,0,1.32-.417,2.549,2.549,0,0,0,.8-1.133,4.446,4.446,0,0,0,.273-1.592,4.319,4.319,0,0,0-.267-1.56,2.411,2.411,0,0,0-.8-1.106A2.1,2.1,0,0,0,3.895,4.1a2.1,2.1,0,0,0-1.293.39,2.341,2.341,0,0,0-.791,1.079A4.437,4.437,0,0,0,1.543,7.182Zm10.668,4.275A3.469,3.469,0,0,1,8.957,9.448a5.007,5.007,0,0,1-.465-2.223,5.068,5.068,0,0,1,.465-2.239,3.7,3.7,0,0,1,5.2-1.486,3.539,3.539,0,0,1,1.3,1.486,5.019,5.019,0,0,1,.47,2.239,4.959,4.959,0,0,1-.47,2.223,3.469,3.469,0,0,1-3.249,2.009Zm0-1.133A2.165,2.165,0,0,0,13.6,9.892a2.552,2.552,0,0,0,.807-1.138,4.358,4.358,0,0,0,.262-1.528,4.4,4.4,0,0,0-.262-1.534A2.585,2.585,0,0,0,13.6,4.542,2.147,2.147,0,0,0,12.212,4.1a2.147,2.147,0,0,0-1.389.438,2.585,2.585,0,0,0-.807,1.149,4.4,4.4,0,0,0-.262,1.534,4.358,4.358,0,0,0,.262,1.528,2.552,2.552,0,0,0,.807,1.138A2.165,2.165,0,0,0,12.212,10.324Zm5.043.962V3.078h1.218v1.24h.086a1.971,1.971,0,0,1,.812-.989A2.391,2.391,0,0,1,20.7,2.95q.139,0,.347.005t.315.016V4.254q-.064-.016-.294-.048a2.893,2.893,0,0,0-.476-.037,2.233,2.233,0,0,0-1.069.251,1.894,1.894,0,0,0-.737.684,1.844,1.844,0,0,0-.267.989v5.194Zm6.258-4.938v4.938H22.251V3.078H23.47V4.361h.107a2.344,2.344,0,0,1,.876-1,2.724,2.724,0,0,1,1.518-.385,2.993,2.993,0,0,1,1.459.342A2.3,2.3,0,0,1,28.4,4.339a3.81,3.81,0,0,1,.347,1.731v5.216H27.488V6.156a2.128,2.128,0,0,0-.5-1.507A1.782,1.782,0,0,0,25.607,4.1a2.2,2.2,0,0,0-1.079.262,1.874,1.874,0,0,0-.743.764A2.523,2.523,0,0,0,23.513,6.349Zm10.57,4.938V3.078h1.261v8.208Zm.641-9.576a.9.9,0,0,1-.636-.251.807.807,0,0,1-.262-.6.807.807,0,0,1,.262-.6A.9.9,0,0,1,34.724,0a.878.878,0,0,1,.631.251.8.8,0,0,1,.267.6.8.8,0,0,1-.267.6A.878.878,0,0,1,34.724,1.71Zm3.589,4.639v4.938H37.052V3.078H38.27V4.361h.107a2.344,2.344,0,0,1,.876-1,2.724,2.724,0,0,1,1.518-.385,2.993,2.993,0,0,1,1.459.342A2.3,2.3,0,0,1,43.2,4.339a3.81,3.81,0,0,1,.347,1.731v5.216H42.289V6.156a2.128,2.128,0,0,0-.5-1.507A1.782,1.782,0,0,0,40.408,4.1a2.2,2.2,0,0,0-1.079.262,1.874,1.874,0,0,0-.743.764A2.523,2.523,0,0,0,38.313,6.349ZM54.7,4.916l-1.133.321a2.107,2.107,0,0,0-.315-.55,1.531,1.531,0,0,0-.556-.449,2.018,2.018,0,0,0-.9-.176,2.156,2.156,0,0,0-1.256.347,1.023,1.023,0,0,0-.5.871.9.9,0,0,0,.342.743,2.856,2.856,0,0,0,1.069.454l1.218.3a3.364,3.364,0,0,1,1.641.818A1.912,1.912,0,0,1,54.847,9a2.084,2.084,0,0,1-.406,1.261,2.692,2.692,0,0,1-1.122.876,4.1,4.1,0,0,1-1.678.321,3.69,3.69,0,0,1-2.079-.545A2.417,2.417,0,0,1,48.52,9.32l1.2-.3a1.664,1.664,0,0,0,.647.994,2.171,2.171,0,0,0,1.256.331,2.347,2.347,0,0,0,1.4-.374,1.1,1.1,0,0,0,.524-.908.955.955,0,0,0-.3-.716,1.91,1.91,0,0,0-.919-.438l-1.368-.321A3.263,3.263,0,0,1,49.3,6.76a2.006,2.006,0,0,1-.524-1.416,2.03,2.03,0,0,1,.39-1.229,2.655,2.655,0,0,1,1.074-.839,3.771,3.771,0,0,1,1.55-.3,3.068,3.068,0,0,1,1.913.534A2.882,2.882,0,0,1,54.7,4.916Zm4.781,6.541a3.435,3.435,0,0,1-3.27-2.047,5.087,5.087,0,0,1-.449-2.186,5.039,5.039,0,0,1,.46-2.207,3.632,3.632,0,0,1,1.293-1.5,3.473,3.473,0,0,1,1.945-.545,3.681,3.681,0,0,1,1.56.321,2.988,2.988,0,0,1,1.138.9,2.8,2.8,0,0,1,.55,1.347H61.445a1.955,1.955,0,0,0-.641-.994A1.919,1.919,0,0,0,59.478,4.1a2.215,2.215,0,0,0-1.293.385,2.507,2.507,0,0,0-.86,1.074,3.98,3.98,0,0,0-.3,1.619,4.221,4.221,0,0,0,.3,1.657,2.537,2.537,0,0,0,.855,1.1,2.211,2.211,0,0,0,1.3.39,2.252,2.252,0,0,0,.892-.171,1.84,1.84,0,0,0,.679-.492,1.885,1.885,0,0,0,.4-.77h1.261a2.92,2.92,0,0,1-.529,1.309,2.956,2.956,0,0,1-1.106.919A3.564,3.564,0,0,1,59.478,11.457Zm4.47-.171V3.078h1.261v8.208Zm.641-9.576a.9.9,0,0,1-.636-.251.807.807,0,0,1-.262-.6.807.807,0,0,1,.262-.6A.9.9,0,0,1,64.589,0a.878.878,0,0,1,.631.251.8.8,0,0,1,.267.6.8.8,0,0,1-.267.6A.878.878,0,0,1,64.589,1.71Zm5.769,9.747a3.861,3.861,0,0,1-2.047-.524,3.515,3.515,0,0,1-1.32-1.475,5.03,5.03,0,0,1-.46-2.212,5.1,5.1,0,0,1,.46-2.223,3.625,3.625,0,0,1,1.293-1.507,3.474,3.474,0,0,1,1.945-.545,3.891,3.891,0,0,1,1.266.214,3.138,3.138,0,0,1,1.138.695,3.325,3.325,0,0,1,.818,1.261,5.377,5.377,0,0,1,.3,1.935V7.61H67.43V6.52h5.045A2.692,2.692,0,0,0,72.2,5.28a2.094,2.094,0,0,0-.78-.86A2.185,2.185,0,0,0,70.23,4.1a2.263,2.263,0,0,0-1.3.374,2.46,2.46,0,0,0-.839.962,2.825,2.825,0,0,0-.294,1.272v.727a3.522,3.522,0,0,0,.321,1.576,2.313,2.313,0,0,0,.9.978,2.647,2.647,0,0,0,1.341.331,2.73,2.73,0,0,0,.9-.139,1.922,1.922,0,0,0,.7-.428,1.943,1.943,0,0,0,.454-.716l1.218.342a2.7,2.7,0,0,1-.647,1.09,3.153,3.153,0,0,1-1.122.727A4.162,4.162,0,0,1,70.358,11.457Zm5.977-5.109v4.938H75.073V3.078h1.218V4.361H76.4a2.344,2.344,0,0,1,.876-1,2.724,2.724,0,0,1,1.518-.385,2.993,2.993,0,0,1,1.459.342,2.3,2.3,0,0,1,.973,1.026,3.81,3.81,0,0,1,.347,1.731v5.216H80.31V6.156a2.128,2.128,0,0,0-.5-1.507A1.782,1.782,0,0,0,78.429,4.1a2.2,2.2,0,0,0-1.079.262,1.874,1.874,0,0,0-.743.764A2.523,2.523,0,0,0,76.334,6.349Zm10.274,5.109a3.435,3.435,0,0,1-3.27-2.047,5.087,5.087,0,0,1-.449-2.186,5.039,5.039,0,0,1,.46-2.207,3.633,3.633,0,0,1,1.293-1.5,3.474,3.474,0,0,1,1.945-.545,3.681,3.681,0,0,1,1.56.321,2.988,2.988,0,0,1,1.138.9,2.8,2.8,0,0,1,.55,1.347H88.575a1.955,1.955,0,0,0-.641-.994A1.919,1.919,0,0,0,86.609,4.1a2.215,2.215,0,0,0-1.293.385,2.507,2.507,0,0,0-.86,1.074,3.98,3.98,0,0,0-.3,1.619,4.219,4.219,0,0,0,.3,1.657,2.536,2.536,0,0,0,.855,1.1,2.211,2.211,0,0,0,1.3.39,2.252,2.252,0,0,0,.892-.171,1.842,1.842,0,0,0,.679-.492,1.885,1.885,0,0,0,.4-.77h1.261a2.922,2.922,0,0,1-.529,1.309,2.956,2.956,0,0,1-1.106.919A3.564,3.564,0,0,1,86.609,11.457Zm7.911,0a3.861,3.861,0,0,1-2.047-.524,3.515,3.515,0,0,1-1.32-1.475,5.03,5.03,0,0,1-.46-2.212,5.1,5.1,0,0,1,.46-2.223,3.625,3.625,0,0,1,1.293-1.507,3.474,3.474,0,0,1,1.945-.545,3.89,3.89,0,0,1,1.266.214A3.138,3.138,0,0,1,96.8,3.88a3.324,3.324,0,0,1,.818,1.261,5.377,5.377,0,0,1,.3,1.935V7.61H91.591V6.52h5.045a2.692,2.692,0,0,0-.278-1.24,2.094,2.094,0,0,0-.78-.86A2.185,2.185,0,0,0,94.391,4.1a2.263,2.263,0,0,0-1.3.374,2.461,2.461,0,0,0-.839.962,2.825,2.825,0,0,0-.294,1.272v.727a3.523,3.523,0,0,0,.321,1.576,2.313,2.313,0,0,0,.9.978,2.646,2.646,0,0,0,1.341.331,2.729,2.729,0,0,0,.9-.139,1.921,1.921,0,0,0,.7-.428,1.941,1.941,0,0,0,.454-.716l1.218.342a2.7,2.7,0,0,1-.647,1.09,3.153,3.153,0,0,1-1.122.727A4.162,4.162,0,0,1,94.52,11.457Z"
              transform="translate(905.696 1264)"
              fill="#fff"
            ></path>
          </g>
        </svg>
      </a>
    </div>
  </div>
  <!-- main container -->
  <div class="main-container" *ngIf="hasContent && firstLoad">
    <div class="main-container-header">
      <h2>
        <span class="target-name">{{ clientName }}</span> Error Overview
      </h2>

      <div class="custom_option_datepicker-container">
        <div class="custom_option_picker custom_datepicker">
          <span class="custom_option_picker-label"> Start Date: </span>
          <input
            matInput
            [matDatepicker]="frequencyStartDatePicker"
            (dateChange)="getFrequencyStartDate($event)"
            [(ngModel)]="frequencyStartDate"
            [(ngModel)]="frequencyStartDate"
            [max]="maxDate"
            [min]="minStartDate"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="frequencyStartDatePicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #frequencyStartDatePicker></mat-datepicker>
        </div>
        <div class="custom_option_picker custom_datepicker">
          <span class="custom_option_picker-label"> End Date: </span>
          <input
            matInput
            [matDatepicker]="frequencyEndDatePicker"
            (dateChange)="getFrequencyEndDate($event)"
            [(ngModel)]="frequencyEndDate"
            [max]="endMaxDate"
            [min]="minDate"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="frequencyEndDatePicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #frequencyEndDatePicker></mat-datepicker>
        </div>
      </div>
    </div>

    <!-- <div class="table-items">
      <div class="table-row">
        <div class="table-column">
          <div class="table-column-header"><p>Issue</p></div>
          <div class="table-column-body">
            <p>{{ bugObject.name }}</p>
          </div>
        </div>
        <div class="table-column">
          <div class="table-column-header"><p>Revenue Loss</p></div>
          <div class="table-column-body">
            <p class="revenue-loss-color">{{ bugObject.revenue_loss }}</p>
          </div>
        </div>
        <div class="table-column">
          <div class="table-column-header"><p>Page</p></div>
          <div class="table-column-body">
            <p>{{ bugObject.page }}</p>
          </div>
        </div>
        <div class="table-column">
          <div class="table-column-header"><p>Category</p></div>
          <div class="table-column-body">
            <p>{{ bugObject.bug_category }}</p>
          </div>
        </div>
        <div class="table-column">
          <div class="table-column-header"><p>Total Errors</p></div>
          <div class="table-column-body">
            <p>{{ bugObject.absolute_value }}</p>
          </div>
        </div>
      </div>
      <div class="table-row">
        <div class="table-column">
          <div class="table-column-header"><p>Total Revenue Loss</p></div>
          <div class="table-column-body">
            <p class="revenue-loss-color">{{ bugObject.totalRevenueLoss }}</p>
          </div>
        </div>
        <div class="table-column table-column-twoSize">
          <div class="table-column-header"><p>Issue Type</p></div>
          <div class="table-column-body">
            <p class="overFlowScroll text-align-left text-breakAll">
              {{ bugObject.full_bug_message }}
            </p>
          </div>
        </div>
        <div class="table-column table-column-twoSize">
          <div class="table-column-header"><p>Top Url</p></div>
          <div class="table-column-body">
            <p class="overFlowScroll text-align-left text-breakAll">
              <a
                *ngFor="let objUrl of bugObject.top_urls"
                [href]="objUrl.url"
                target="_blank"
                >{{ objUrl.url }}</a
              >
            </p>
          </div>
        </div>
      </div>
    </div> -->
    <div class="trace-errors-info_container">
      <div class="trace-errors-info_container-child">
        <div class="trace-errors-info_container-item">
          <p class="trace-errors-info_container-item-title">Issue</p>
          <p
            class="trace-errors-info_container-item-text"
            [matTooltip]="bugObject.name"
            matTooltipPosition="above"
            [ngClass]="{
              'trace-errors-info_container-item-text_capitalize':
                bugObject.showName == 'recommendation image error'
            }"
          >
            {{ bugObject.showName }}
          </p>
        </div>
        <div class="trace-errors-info_container-item">
          <p class="trace-errors-info_container-item-title">Revenue loss</p>
          <p class="trace-errors-info_container-item-text">
            {{ bugObject.revenue_loss }}
          </p>
        </div>
        <div
          class="trace-errors-info_container-item"
          *ngIf="bugObject.showName !== 'Image Size'"
        >
          <p class="trace-errors-info_container-item-title">Total Errors</p>
          <p class="trace-errors-info_container-item-text">
            {{ bugObject.absolute_value }}
          </p>
        </div>
        <div class="trace-errors-info_container-item">
          <p class="trace-errors-info_container-item-title">Page</p>
          <p class="trace-errors-info_container-item-text">
            {{ bugObject.page }}
          </p>
        </div>
        <div class="trace-errors-info_container-item">
          <p class="trace-errors-info_container-item-title">Category</p>
          <p class="trace-errors-info_container-item-text">
            {{ bugObject.bug_category }}
          </p>
        </div>
        <div
          class="trace-errors-info_container-item"
          *ngIf="bugObject.showName !== 'Image Size'"
        >
          <p class="trace-errors-info_container-item-title">First seen</p>
          <p class="trace-errors-info_container-item-text">
            {{ bugObject.firstDateOfBug ? bugObject.firstDateOfBug : "-" }}
          </p>
        </div>
      </div>
      <div class="trace-errors-info_container-child issue_type_container">
        <div class="trace-errors-info_container-item">
          <p class="trace-errors-info_container-item-title">
            {{
              bugObject.bug_category == "Source Code Error"
                ? "File sequences"
                : "Issue Type"
            }}
          </p>
          <p class="trace-errors-info_container-item-text">
            <ng-container *ngIf="bugObject.showName !== 'Image Size'">
              {{ show_full_bug_message }}
            </ng-container>
            <ng-container *ngIf="bugObject.showName === 'Image Size'">
              Excessively large image assets causing slow page load times,
              increased bandwidth usage, and poor performance due to missing
              compression, oversized files, or unoptimized formats.
            </ng-container>
          </p>
        </div>
      </div>
    </div>

    <div
      style="
        margin-top: 30px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 20px;
      "
    >
      <p style="margin: 0; font-size: 16px; font-weight: 600">Total Errors</p>
      <div
        class="custom_option_picker custom_option_picker_width60"
        style="margin: 2px"
      >
        <span class="custom_option_picker-label"> Rate: </span>
        <mat-form-field>
          <mat-select [(ngModel)]="rate" (selectionChange)="onRateChange(rate)">
            <mat-option value="hourly"> Hourly </mat-option>
            <mat-option value="day" [disabled]="isDayDisabled">
              Day
            </mat-option>
            <mat-option value="month" [disabled]="isMonthDisabled">
              Month
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="linechart-container">
      <google-chart
        class="chart"
        [data]="bugLineChart"
        *ngIf="loadChart"
        (window:resize)="onResize($event)"
      >
      </google-chart>
    </div>

    <h2
      *ngIf="firstLoad && bugObject.showName === 'Image Size'"
      class="custom_table-container-h2 subtitle-h2"
    >
      Images
    </h2>
    <div *ngIf="firstLoad && bugObject.showName === 'Image Size'">
      <div class="custom_table-container">
        <table class="custom_table">
          <thead>
            <tr>
              <th class="width50 minWidth20"><div>#</div></th>
              <th><div>URL</div></th>
              <th class="text_align-right minWidth20"><div>Size</div></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of bugObject.top_urls; let i = index">
              <td class="width50 minWidth20">{{ i + 1 }}</td>
              <td style="font-size: 14px; font-weight: 400">
                <div
                  class="content_page_body_item"
                  (click)="openInNewTab(item.url)"
                >
                  <p class="long-title">
                    {{ item.url }}
                  </p>
                  <svg
                    viewBox="0 0 640 512"
                    class="content_page_body_item_url_icon"
                  >
                    <path
                      d="M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"
                    />
                  </svg>
                </div>
              </td>
              <td class="text_align-right minWidth20">
                {{ formatBytesToKb(item.size) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div
      style="
        margin-top: 30px;
        margin-bottom: 30px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      "
      *ngIf="bugObject.showName !== 'Image Size'"
    >
      <p style="margin: 0; font-size: 16px; font-weight: 600">User Sessions</p>
    </div>
    <div
      class="trace-errors-tmpSession-container"
      *ngIf="bugObject.showName !== 'Image Size'"
    >
      <div class="left-side">
        <div
          class="trace-errors-errorsVisit-item"
          *ngFor="let visit of errorsVisitData"
          [ngClass]="{ active: visit.cssActive }"
          (click)="getVisitDetails(visit)"
        >
          <p>
            {{ visit.tempSessionID }}
          </p>
          <!-- <span
            class="trace-errors-errorsVisit-item-play_icon"
            *ngIf="visit.readyToPlay"
          >
            <svg
              width="10"
              height="12"
              viewBox="0 0 15 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.97067e-08 1.00004V17C-5.0094e-05 17.178 0.0473748 17.3527 0.137382 17.5062C0.227388 17.6597 0.356717 17.7864 0.512024 17.8732C0.667332 17.96 0.842993 18.0038 1.02088 18.0001C1.19878 17.9964 1.37245 17.9453 1.524 17.852L14.524 9.85204C14.6696 9.76257 14.7898 9.63728 14.8733 9.48813C14.9567 9.33897 15.0005 9.17093 15.0005 9.00004C15.0005 8.82915 14.9567 8.6611 14.8733 8.51195C14.7898 8.3628 14.6696 8.23751 14.524 8.14804L1.524 0.148038C1.37245 0.0548024 1.19878 0.00368998 1.02088 -2.59846e-05C0.842993 -0.00374195 0.667332 0.0400731 0.512024 0.126899C0.356717 0.213724 0.227388 0.340415 0.137382 0.493901C0.0473748 0.647386 -5.0094e-05 0.822108 3.97067e-08 1.00004Z"
                [style.fill]="isDarkMode ? '#fff' : '#000'"
              />
            </svg>
          </span> -->
        </div>
        <div
          *ngIf="displayShowMore && !showMoreLoader"
          class="trace-errors-errorsVisit-item show-more"
        >
          <p (click)="getErrorVisits(1)">Show more</p>
        </div>
        <div class="loading" *ngIf="showMoreLoader && !isLoading">
          <div class="loading-bar"></div>
          <div class="loading-bar"></div>
          <div class="loading-bar"></div>
          <div class="loading-bar"></div>
        </div>
      </div>
      <div class="right-side">
        <div class="trace-errors-userAgent">
          <ng-container *ngIf="userAgentObject">
            <p
              matTooltip="Device Type and Operating System"
              matTooltipPosition="above"
              *ngIf="
                userAgentObject?.device?.model ||
                userAgentObject?.os?.name ||
                userAgentObject?.os?.version
              "
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_2473_3102)">
                  <path
                    d="M13 9C13 8.73478 13.1054 8.48043 13.2929 8.29289C13.4804 8.10536 13.7348 8 14 8H20C20.2652 8 20.5196 8.10536 20.7071 8.29289C20.8946 8.48043 21 8.73478 21 9V19C21 19.2652 20.8946 19.5196 20.7071 19.7071C20.5196 19.8946 20.2652 20 20 20H14C13.7348 20 13.4804 19.8946 13.2929 19.7071C13.1054 19.5196 13 19.2652 13 19V9Z"
                    [style.stroke]="isDarkMode ? '#fff' : '#000'"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M18 8V5C18 4.73478 17.8946 4.48043 17.7071 4.29289C17.5196 4.10536 17.2652 4 17 4H4C3.73478 4 3.48043 4.10536 3.29289 4.29289C3.10536 4.48043 3 4.73478 3 5V17C3 17.2652 3.10536 17.5196 3.29289 17.7071C3.48043 17.8946 3.73478 18 4 18H13"
                    [style.stroke]="isDarkMode ? '#fff' : '#000'"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M16 9H18"
                    [style.stroke]="isDarkMode ? '#fff' : '#000'"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2473_3102">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>

              <span>
                {{ userAgentObject?.device?.model }}
              </span>
              <span>
                {{ userAgentObject?.os?.name }}
                {{ userAgentObject?.os?.version }}
              </span>
            </p>
            <p
              matTooltip="Device Browser"
              matTooltipPosition="above"
              *ngIf="
                userAgentObject?.browser?.name ||
                userAgentObject?.browser?.version
              "
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_2473_3110)">
                  <path
                    d="M4 5C4 4.73478 4.10536 4.48043 4.29289 4.29289C4.48043 4.10536 4.73478 4 5 4H19C19.2652 4 19.5196 4.10536 19.7071 4.29289C19.8946 4.48043 20 4.73478 20 5V19C20 19.2652 19.8946 19.5196 19.7071 19.7071C19.5196 19.8946 19.2652 20 19 20H5C4.73478 20 4.48043 19.8946 4.29289 19.7071C4.10536 19.5196 4 19.2652 4 19V5Z"
                    [style.stroke]="isDarkMode ? '#fff' : '#000'"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M4 8H20"
                    [style.stroke]="isDarkMode ? '#fff' : '#000'"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M8 4V8"
                    [style.stroke]="isDarkMode ? '#fff' : '#000'"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2473_3110">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>

              <span>
                {{ userAgentObject?.browser?.name }}
              </span>
              <span>
                {{ userAgentObject?.browser?.version }}
              </span>
            </p>
            <p
              matTooltip="Connection Type"
              matTooltipPosition="above"
              *ngIf="connectionType"
              class="connection-type"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_2473_3092)">
                  <path
                    d="M12 18H12.01"
                    [style.stroke]="isDarkMode ? 'white' : 'black'"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9.17188 15.1721C9.92199 14.4222 10.9392 14.001 11.9999 14.001C13.0605 14.001 14.0778 14.4222 14.8279 15.1721"
                    [style.stroke]="isDarkMode ? 'white' : 'black'"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M6.34277 12.3428C7.08565 11.5999 7.96758 11.0106 8.93821 10.6085C9.90884 10.2065 10.9492 9.99951 11.9998 9.99951C13.0504 9.99951 14.0907 10.2065 15.0613 10.6085C16.032 11.0106 16.9139 11.5999 17.6568 12.3428"
                    [style.stroke]="isDarkMode ? 'white' : 'black'"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M3.51465 9.51476C8.20065 4.82776 15.7986 4.82776 20.5146 9.51476"
                    [style.stroke]="isDarkMode ? 'white' : 'black'"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2473_3092">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>

              <span>
                {{ connectionType }}
              </span>
            </p>
          </ng-container>
          <!-- <button
            class="btn_withoutIcon custom-button"
            mat-raised-button
            type="button"
            style="padding: 4px 8px; margin: 1px 6px 1px auto"
            *ngIf="readyToPlay"
            (click)="redirectToRecording()"
          >
            <div style="display: flex; align-items: center">
              <svg
                width="10"
                height="12"
                viewBox="0 0 15 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style="margin-right: 5px"
              >
                <path
                  d="M3.97067e-08 1.00004V17C-5.0094e-05 17.178 0.0473748 17.3527 0.137382 17.5062C0.227388 17.6597 0.356717 17.7864 0.512024 17.8732C0.667332 17.96 0.842993 18.0038 1.02088 18.0001C1.19878 17.9964 1.37245 17.9453 1.524 17.852L14.524 9.85204C14.6696 9.76257 14.7898 9.63728 14.8733 9.48813C14.9567 9.33897 15.0005 9.17093 15.0005 9.00004C15.0005 8.82915 14.9567 8.6611 14.8733 8.51195C14.7898 8.3628 14.6696 8.23751 14.524 8.14804L1.524 0.148038C1.37245 0.0548024 1.19878 0.00368998 1.02088 -2.59846e-05C0.842993 -0.00374195 0.667332 0.0400731 0.512024 0.126899C0.356717 0.213724 0.227388 0.340415 0.137382 0.493901C0.0473748 0.647386 -5.0094e-05 0.822108 3.97067e-08 1.00004Z"
                  [style.fill]="isDarkMode ? '#fff' : '#000'"
                />
              </svg>
              <span>Replay</span>
            </div>
          </button> -->
        </div>
        <div class="trace-errors-events-container">
          <div
            class="trace-errors-event"
            *ngFor="let event of visitDetailsEvents; let idx = index"
            [ngClass]="{
              noEvents: event.events && event.events.length === 0
            }"
          >
            <div
              class="events-sections event-upper-section"
              *ngIf="!event.noData"
            >
              <div class="event-time">
                <p *ngIf="event.time">
                  {{ event.time }}
                </p>
              </div>
              <div class="event-type" *ngIf="event.page">
                <p>
                  {{ event.page }}
                </p>
              </div>
              <div class="event-location">
                <p *ngIf="event.productID && !demoClient">
                  Product ID: {{ event.productID }}
                </p>
                <p *ngIf="event.productID && demoClient">Product ID: Hidden</p>
                <a
                  *ngIf="event.location && !demoClient"
                  [href]="event.location"
                  target="_blank"
                  matTooltip="Open in new tab"
                  matTooltipPosition="above"
                  [style.color]="isDarkMode ? '#fff' : ''"
                >
                  Link
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style="
                      position: absolute;
                      top: -4px;
                      left: calc(100% + 5px);
                    "
                  >
                    <g clip-path="url(#clip0_2475_3328)">
                      <path
                        d="M9 15L15 9"
                        [style.stroke]="isDarkMode ? '#fff' : '#6161FF'"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M11 5.99982L11.463 5.46382C12.4008 4.52614 13.6727 3.99942 14.9989 3.99951C16.325 3.99961 17.5968 4.52651 18.5345 5.46432C19.4722 6.40212 19.9989 7.67401 19.9988 9.00017C19.9987 10.3263 19.4718 11.5981 18.534 12.5358L18 12.9998"
                        [style.stroke]="isDarkMode ? '#fff' : '#6161FF'"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M13.0001 18L12.6031 18.534C11.6544 19.4722 10.3739 19.9984 9.03964 19.9984C7.70535 19.9984 6.42489 19.4722 5.47614 18.534C5.0085 18.0716 4.63724 17.521 4.38385 16.9141C4.13047 16.3073 4 15.6561 4 14.9985C4 14.3408 4.13047 13.6897 4.38385 13.0829C4.63724 12.476 5.0085 11.9254 5.47614 11.463L6.00014 11"
                        [style.stroke]="isDarkMode ? '#fff' : '#6161FF'"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_2475_3328">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </a>
                <span
                  *ngIf="event.location && demoClient"
                  style="
                    position: relative;
                    display: block;
                    word-break: break-all;
                    text-decoration: none;
                    margin-top: 5px;
                    font-size: 13px;
                  "
                  matTooltip="Link of the product"
                  matTooltipPosition="above"
                >
                  Link
                  <mat-icon
                    style="
                      font-size: 16px;
                      margin: -5px -5px -10px 5px !important;
                      position: relative;
                      top: 2px;
                    "
                    >open_in_new</mat-icon
                  >
                </span>
              </div>
            </div>
            <div
              class="events-sections event-down-section"
              *ngIf="!event.noData"
            >
              <div class="event-time"></div>
              <div class="event-type"></div>
              <div class="event-steps-container">
                <div class="event-steps" *ngFor="let e of event.events">
                  <div class="event-steps-icon" [ngClass]="e.class">
                    <p *ngIf="e.name && e.name.length > 0">
                      {{ e.name }}
                    </p>
                  </div>
                  <div class="event-stepsInfo">
                    <p>
                      <span
                        class="event-steps-span event-steps-url"
                        *ngIf="e.resUrl && !demoClient"
                      >
                        Url: <b>{{ e.resUrl }}</b>
                      </span>
                      <span *ngIf="e.resUrl && demoClient">
                        Url: <b> Hidden url</b>
                      </span>
                      <span class="event-steps-span" *ngIf="e.method">
                        Method: <b>{{ e.method }}</b>
                      </span>
                      <span
                        class="event-steps-span event-steps-status"
                        *ngIf="e.resStatus"
                      >
                        Status: <b>{{ e.resStatus }}</b>
                      </span>
                      <span class="event-steps-span">
                        <span
                          *ngIf="e.status && e.name != 'click' && !demoClient"
                          (click)="copyToClipboard(e.status)"
                          class="event-step-response"
                          [ngClass]="{ pointer: enableCopy }"
                        >
                          Response
                          <pre>{{ e.showStatus }}</pre>
                        </span>
                        <span
                          *ngIf="e.status && e.name != 'click' && demoClient"
                          class="event-step-response"
                        >
                          Response
                          <pre>Hidden for Demo</pre>
                        </span>
                        <span
                          class="event-step-click"
                          *ngIf="e.name == 'click'"
                        >
                          Event: <b>{{ e.status }}</b>
                        </span>
                        <span class="event-link" *ngIf="e.link && !demoClient">
                          <a
                            [href]="e.link"
                            target="_blank"
                            matTooltip="Preview Image"
                            matTooltipPosition="above"
                          >
                            <mat-icon>open_in_new</mat-icon>
                          </a>
                        </span>
                      </span>
                    </p>
                  </div>
                </div>
                <div
                  class="event-steps-full_message"
                  *ngIf="idx == bugSocketID && !hideBottomDesc && !demoClient"
                >
                  <p>{{ show_full_bug_message }}</p>
                </div>
                <div
                  class="event-steps-full_message"
                  *ngIf="
                    idx == visitDetailsEventsLength &&
                    !hideBottomDesc &&
                    demoClient
                  "
                >
                  <p>Hidden for demo</p>
                </div>
              </div>
            </div>
            <!-- No Data container -->
            <div class="events-sections" *ngIf="event.noData">
              <p>{{ event.noData }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="trace-errors-piecharts-container"
      style="margin: 30px 0"
      *ngIf="firstLoad && !hidePieCharts"
    >
      <div class="bug-behavioral-piechart-container">
        <ng-container *ngIf="loadBrowserImpactChart">
          <p class="trace-errors-piecharts-container_title">Browser Impact</p>
          <div class="bug-behavioral-detailed-card-chart-g">
            <google-chart
              class="chart piechart"
              [data]="browserImpactPieChart"
              (window:resize)="onResize($event)"
            >
            </google-chart>
          </div>
          <div class="trace-errors-piecharts-container_total">
            {{ browserImpactTotal }}
            <span>Total</span>
          </div>
          <div class="bugPieChart-lengend-container">
            <div
              class="bugPieChart-lengend"
              *ngFor="let legend of browserImpactPieChartLegend"
            >
              <div class="bugPieChart-lengend_flex">
                <div
                  class="bugPieChart-lengend-dot"
                  [ngStyle]="{ 'background-color': legend.color }"
                ></div>
                <p>{{ legend.name }}</p>
              </div>
              <div class="bugPieChart-lengend_value">
                <p>{{ legend.relative_value }}</p>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="bug-behavioral-piechart-container">
        <ng-container *ngIf="loadOSImpactChart">
          <p class="trace-errors-piecharts-container_title">OS Impact</p>
          <div class="bug-behavioral-detailed-card-chart-g">
            <google-chart
              class="chart piechart"
              [data]="osImpactPieChart"
              (window:resize)="onResize($event)"
            >
            </google-chart>
          </div>
          <div class="trace-errors-piecharts-container_total">
            {{ osImpactTotal }}
            <span>Total</span>
          </div>
          <div class="bugPieChart-lengend-container">
            <div
              class="bugPieChart-lengend"
              *ngFor="let legend of osImpactPieChartLegend"
            >
              <div class="bugPieChart-lengend_flex">
                <div
                  class="bugPieChart-lengend-dot"
                  [ngStyle]="{ 'background-color': legend.color }"
                ></div>
                <p>{{ legend.name }}</p>
              </div>
              <div class="bugPieChart-lengend_value">
                <p>{{ legend.relative_value }}</p>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="loading-bug-data-overlay" *ngIf="isLoading">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  </div>

  <!-- alert container -->
  <div class="main-container alert-container" *ngIf="!hasContent && firstLoad">
    <p class="alert-message">
      The authenticated link is incorrect or has expired.
    </p>
    <p>Please contact the Behamics support team.</p>
  </div>

  <div class="main-container" *ngIf="!firstLoad">
    <ngx-skeleton-loader
      count="1"
      [theme]="{
        height: '50px',
        outline: 'none',
        'background-color': '#37474f1a',
        'margin-bottom': '40px'
      }"
    ></ngx-skeleton-loader>
    <ngx-skeleton-loader
      count="1"
      [theme]="{
        height: '200px',
        outline: 'none',
        'background-color': '#37474f1a',
      }"
    ></ngx-skeleton-loader>
    <ngx-skeleton-loader
      count="2"
      [theme]="{
        height: '200px',
        outline: 'none',
        'background-color': '#37474f1a',
        'margin-top': '20px'
      }"
    ></ngx-skeleton-loader>
  </div>
</div>
